import React from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import { cssMap, cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import VisuallyHidden from '@atlaskit/visually-hidden';

const styles = cssMap({
	wrapper: {
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
		width: '360px',
		minHeight: '360px',
	},
});

const messages = defineMessages({
	loading: {
		id: 'platform.navigation-experiences.universal-create.integrations.form-loading',
		defaultMessage: 'Loading',
		description: 'loading message',
	},
});

export function FormLoading() {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={cx(styles.wrapper)}>
			<VisuallyHidden id={messages.loading.id}>{formatMessage(messages.loading)}</VisuallyHidden>
		</Box>
	);
}
